import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

function FichaTecnicaPDF(data){

    pdfMake.vfs = pdfFonts.pdfMake.vfs;


    const docDefinition = {
        content: [
          { text: `Ficha Técnica: ${data.descricao}`, style: 'header' },
          {
            table: {
              widths: ['auto', '*', 'auto', 'auto', 'auto'],
              body: [
                ['Código', 'Descrição', 'Compra', 'Markup', 'Venda'],
                [
                  data.cod,
                  data.descricao,
                  { text: `R$ ${data.compra.toFixed(2)}`, alignment: 'right' },
                  { text: `${data.markup.toFixed(2)}%`, alignment: 'right' },
                  { text: `R$ ${data.venda.toFixed(2)}`, alignment: 'right' },
                 
                ]
              ]
            },
            margin: [0, 10, 0, 10]
          },
          { text: 'Componentes Adicionados', style: 'subheader' },
          {
            table: {
              widths: ['auto', '*', 'auto', 'auto', 'auto'],
              body: [
                ['Código', 'Descrição', 'Quantidade', 'Venda', 'Custo'],
                ...data.componentes.map(comp => [
                  comp.CODIGO,
                  comp.DESCRICAO,
                  { text: comp.QUANTIDADE, alignment: 'right' },
                  { text: `R$ ${comp.COMPRACOMPONENTE.toFixed(2)}`, alignment: 'right' },
                  { text: `R$ ${comp.CUSTOCOMPONENTE.toFixed(2)}`, alignment: 'right' }
                ])
              ]
            },
            margin: [0, 10, 0, 10]
          },
          { text: 'Modo de Preparo', style: 'subheader' },
          { text: data.modo, margin: [0, 5, 0, 15] }
        ],
        styles: {
          header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
          subheader: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] }
        }
      };
    
      pdfMake.createPdf(docDefinition).open();
    }


export default FichaTecnicaPDF;